import { Component, ComponentFactoryResolver, EventEmitter, Injector, OnChanges, OnInit } from '@angular/core';
import * as moment from 'moment';
import { SearchResultService } from '../../../shared/components/search/search-results/search-result.service';
import { ShortDatePipe } from '../../../shared/pipes/short-date.pipe';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { RegistrationUseType } from '../../../titleregistration/models/enums/registration-use-type.enum';
import { VehicleAddModalComponent, VehicleAddModalData } from '../../components/shared/vehicle/vehicle-add-modal/vehicle-add-modal.component';
import { VehicleType } from '../../models/enums/vehicle-type.enum';

@Component({
    selector: 'vehicle-search-results',
    inputs: ['results', 'searchString', 'context', 'readonly', 'hideSelect'],
    outputs: ['onItemSelected', 'onVinClicked'],
    templateUrl: './vehicle-search-results.html'
})

export class VehicleSearchResultsComponent implements OnInit, OnChanges {
    public results: any[];
    public displayResults: boolean;
    private searchString: string;
    public readonly: boolean;
    public hideSelect: boolean;
    public onItemSelected: EventEmitter<any>;
    public onVinClicked: EventEmitter<any>;

    private vehicleType = new VehicleType();
    private registrationUseType = new RegistrationUseType();

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private injector: Injector,
        private searchResultService: SearchResultService,
        public modalService: MvdModalService,
        private shortDatePipe: ShortDatePipe) {
        this.displayResults = false;
        this.onItemSelected = new EventEmitter<any>();
        this.onVinClicked = new EventEmitter<any>();
    }

    async ngOnInit() {
        this.searchResultService.receiveContext(this.componentFactoryResolver, this.injector);
        this.ngOnChanges();
    }

    public ngOnChanges() {
        if (this.results.length === 1) {
            this.onItemSelected.emit(this.results[0]);
        } else {
            this.displayResults = true;
            for (let i = 0; i < this.results.length; i++) {
                if (this.results[i].registrationEndDate) {
                    this.results[i].registrationEndDate = moment(this.results[i].registrationEndDate).toDate();
                } else {
                    this.results[i].registrationEndDate = null;
                }
            }
        }
    }

    public onSelect = (result: any): void => {
        this.onItemSelected.emit(result);
    };

    public onVinClick = (result: any): void => {
        this.onVinClicked.emit(result);
    };

    public onAddVehicle = (): void => {
        const data = new VehicleAddModalData(null, this.searchString, false, 'Add New Vehicle', false);
        this.modalService.open(VehicleAddModalComponent, data);
    };

    public getRegistrationEndDateFormatted = (row: any): string => {
        if (!row) {
            return '';
        }

        if ((row.vehicleTypeId == this.vehicleType.Trailer.id ||
             row.vehicleTypeId == this.vehicleType.TentTrailer.id ||
             row.vehicleTypeId == this.vehicleType.TravelTrailer.id) &&
            (row.registrationUseTypeId == this.registrationUseType.NonCommercialPermanentTrailer.id ||
             row.registrationUseTypeId == this.registrationUseType.CommercialPermanentTrailer.id)) {
            return 'Perm';
        }

        return this.shortDatePipe.transform(row.registrationEndDate);
    };
}
